<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_generateCount') || '新增数量'"
            prop="generateCount"
          >
            <el-input-number
              v-model="formData.generateCount"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="1"
              :step="1"
              :max="100"
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_is_last') || '是否末级'"
            prop="isLast"
          >
            <el-select
              v-model="formData.isLast"
              :disabled="disabledIsLast"
              style="width:100%"
            >
              <el-option
                :label="$l('form_label_is_last_yes') || '是'"
                value="Y"
              />
              <el-option
                :label="$l('form_label_is_last_no') || '否'"
                value="N"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_locType') || '库位类型'"
            prop="locType"
          >
            <dict-select
              v-model="formData.locType"
              url="/sys/common/dict/system"
              :body="{ dictType: 'locType' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_locSellType') || '库位售卖类型'"
            prop="locSellType"
          >
            <dict-select
              v-model="formData.locSellType"
              url="/sys/common/dict/system"
              :body="{ dictType: 'locSellType' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import store from '../../store'
export default {
  mixins: [EditLoading],
  data() {
    return {
      formData: { generateCount: 1, isLast: 'Y' },
      backDialogVisible: false,
      rules: {
        generateCount: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        isLast: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        locType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        locSellType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
    disabledIsLast() {
      const { classLevel } = this.selected
      return classLevel === 0
    },
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const { locationCode: parentCode, classLevel } = this.selected

      if (this.loadingOpen()) return
      const params = {
        ...this.formData,
        parentCode,
        classLevel: classLevel - 0 + 1,
      }
      const res = await this.$api
        .masterLocationGenerateApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
